const colors = {
  black: '#000000',
  white: '#ffffff',
  success: '#679937',
  warning: '#ed6c02',
  error: '#d32f2f',
  inactive: '#ff0000',
  scheduled: '#fad201',
  pending: '#f0f8ff',
  discount: '#008000',
};

export default colors;
